import { APIFactory } from '../../ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from '../../ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import { ITaxCertificationData } from '../../ui-toolkit/taxCertifications/ITaxCertification';

export interface IPutTaxCertificationsAsyncProps {
  taxCertification: ITaxCertificationData;
  orderId: string;
}

export const saveTaxCertificationsAsync = ({ taxCertification, orderId }: IPutTaxCertificationsAsyncProps) =>
  APIFactory(baseUrlService.ApiLocation)
    .put(`/lender/v1/vendor/orders/${orderId}/tax_certifications/${taxCertification.id}`, taxCertification)
    .then((response) => response.data)
    .catch(axiosErrorHandler);
